import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/shrl.config';
import { ShrlComponent } from './app/shrl.component';

bootstrapApplication(ShrlComponent, appConfig).catch((err) =>
  console.error(err)
);
